export const SortFilterCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
